import { render } from "./Assignment.vue?vue&type=template&id=9a4ece4c&scoped=true&ts=true"
import script from "./Assignment.vue?vue&type=script&lang=ts"
export * from "./Assignment.vue?vue&type=script&lang=ts"

import "./Assignment.vue?vue&type=style&index=0&id=9a4ece4c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a4ece4c"]])

export default __exports__